import { module } from "angular";
import { MessageFormatInterpolationService } from "./MessageFormatInterpolationService";

module("mmGlobalisation")
    /**
     * @ngdoc property
     * @name pascalprecht.translate.TRANSLATE_MF_INTERPOLATION_CACHE
     * @requires TRANSLATE_MF_INTERPOLATION_CACHE
     *
     * @description
     * Uses MessageFormat.js to interpolate strings against some values.
     */
    .constant("TRANSLATE_MF_INTERPOLATION_CACHE", "$translateMessageFormatInterpolation")

    /**
     * @ngdoc object
     * @name pascalprecht.translate.$translateMessageFormatInterpolationProvider
     *
     * @description
     * Configurations for $translateMessageFormatInterpolation
     */
    .service("$irTranslateMessageFormatInterpolation", MessageFormatInterpolationService);
